import { UNIVERSITY } from '~/consts';

export const state = () => ({
  active: null,
  default: null,
  me: [],
  list: [],
  current_schedule: [],
  week_schedules: [],
  web_reg_id: null,
  periods: helpers.getDefaultPeriods(),
  activePeriod: null
})

export const mutations = {
  setDefault(state, university) {
    state.default = university;
  },
  setMe(state, universities) {
    state.me = universities;
  },
  setList(state, universities) {
    state.list = universities;
  },
  setCurrentSchedule(state, schedule) {
    state.current_schedule = schedule;
  },
  setWeekSchedules(state, schedules) {
    state.week_schedules = schedules;
  },
  setWebRegId(state, token) {
    state.web_reg_id = token;
  },
  resetUniversitiesState(state) {
    state.default = null;
    state.me = [];
    state.list = [];
    state.current_schedule = [];
    state.week_schedules = [];
    state.web_reg_id = null;
    state.periods = helpers.getDefaultPeriods();
    state.activePeriod = null;
  },
  setState(state, item) {
    state[item.key] = item.value
  }
}

export const actions = {
  async getMe({ commit, dispatch }) {
    let { data } = await this.$axios.post(UNIVERSITY.GET_ME);

    if (data.applicationSystem.code == 0) {
      let universities = [];

      if (!helpers.isEmpty(data.data)) {
        universities = data.data;
      }

      this.dispatch('getProfile');
      commit('setMe', universities);
      const default_uni_user = collect(universities).where('isDefault', true).first();
      commit('setDefault', default_uni_user);
    }
  },
  getList({ commit, state }) {
    this.$axios.post(UNIVERSITY.GET_ACTIVE).then(({ data }) => {
      if (data.applicationSystem.code == 0) {
        commit('setList', data.data);
      }
    });
  },
  async getKrs({ commit, state }, {id, postData}) {
    return await this.$axios.post(UNIVERSITY.GET_KRS(id), postData, {
      timeout: 15000
    });
  },
  async getKhs({ commit, state }, {id, postData}) {
    return await this.$axios.post(UNIVERSITY.GET_KHS(id), postData, {
      timeout: 15000
    });
  },
  async getTranscript({ commit, state }, {id, postData}) {
    return await this.$axios.post(UNIVERSITY.GET_TRANSCRIPT(id), postData, {
      timeout: 15000
    });
  },
  async getGrade({ commit, state }, {id, postData}) {
    return await this.$axios.post(UNIVERSITY.GET_GRADE(id), postData, {
      timeout: 15000
    });
  },
  getCurrentSchedule({ commit, state }) {
    this.$axios.post(UNIVERSITY.GET_CURRENT_SCHEDULE, {
      user_university_id: state.default.userUniversityId,
      isDefault: state.default.isDefault ? 1 : 0
    }, {
      timeout: 15000
    }).then(({ data }) => {
      if (data.applicationSystem.code == 0) {
        commit('setCurrentSchedule', data.data);
      }
    }).catch(() => {
      toast.danger('Server Universitas anda tidak terhubung. Mohon hubungi pihak Kampus');
    });
  },
  getWeekSchedules({ commit }) {
    this.$axios.post(UNIVERSITY.GET_WEEK_SCHEDULES, {
      isDefault: 1,
      periode: this.$cookies.get('period'),
    }).then(({ data }) => {
      if (data.applicationSystem.code == 0) {
        commit('setWeekSchedules', data.data);
      }
    }).catch(() => {

    });
  },
  setDefault(store, id) {
    const { state, dispatch } = store;

    this.$axios.post(UNIVERSITY.SET_DEFAULT(id), {
      web_reg_id: state.web_reg_id
    })
      .then(({ data }) => {
        if (data.applicationSystem.code == 0) {
          this.dispatch('getProfile');
          if (this.$router.currentRoute.name != 'panel-university') {
            this.$router.push({ name: 'panel' });
          }

          toast.success(data.applicationSystem.message);
        }
      });
  },
  async getActivePeriods({ commit }, active_only = false) {
    try {
      const { data } = await this.$axios.post(UNIVERSITY.GET_PERIODS + `?ao=${active_only === true ? '1' : '0' }`);

      if (data.applicationSystem.code === 0) {
        commit('setState', { key: "periods", value: data.data ?? [] });
        commit('setState', { key: "activePeriod", value: data.data.filter(period => period.status === 1)[0] });
      }
    } catch (err) {}
  },
  removePT({ state, dispatch }, id) {
    if (confirm('Anda akan menghapus akun dari perguruan tinggi ini, lanjutkan?')) {
      this.$axios.post(UNIVERSITY.LOGOUT, {user_university_id: id}).then(({ data }) => {
        if (data.applicationSystem.code == 0) {
          dispatch('getMe');
        }

        toast.info(data.applicationSystem.message);
      });
    }
  }
}
